import { useState } from 'react';
import api from '../../api';
import stili from '../competenze/stili';

const DA_CONTROLLARE = { background: '#fff7ed', border: '1px solid #fdba74', borderRadius: '6px', padding: '0.4rem 0.6rem' };

// Menù dei CCNL in archivio (codice · nome), preselezionato dal codice letto dal PDF; se il codice non c'è si può aggiungere (codice e nome)
export default function SceltaCcnl({ id, valore, onCambia, letto = null, elenco, ricarica, puoScrivere, evidenzia = false, obbligatorio = false }) {
  const [aggiungi, setAggiungi] = useState(false);
  const [nuovo, setNuovo] = useState({ codice: letto ? letto.codice : '', descrizione: letto ? letto.descrizione : '' });
  const [errore, setErrore] = useState('');
  const mancante = Boolean(letto) && !elenco.some(c => c.codice === letto.codice);
  const salva = async () => {
    setErrore('');
    try {
      const r = await api.post('/scadenze/unilav/ccnl', nuovo);
      await ricarica();
      onCambia(r.data.codice);
      setAggiungi(false);
    } catch (err) { setErrore(err.response?.data?.errore || 'Non è stato possibile aggiungere il CCNL'); }
  };
  return (
    <div style={{ ...stili.campo, ...((evidenzia || (mancante && !valore)) ? DA_CONTROLLARE : {}) }}>
      <label style={stili.label} htmlFor={id}>CCNL{obbligatorio ? ' *' : ''}</label>
      <select id={id} value={aggiungi ? '__nuovo' : (valore || '')} style={stili.input}
        onChange={e => (e.target.value === '__nuovo' ? setAggiungi(true) : (setAggiungi(false), onCambia(e.target.value)))}>
        <option value="">{mancante ? `Codice ${letto.codice} non in archivio…` : 'Scegli il CCNL…'}</option>
        {elenco.map(c => <option key={c.codice} value={c.codice}>{c.codice} · {c.descrizione}</option>)}
        {puoScrivere && <option value="__nuovo">+ Aggiungi un CCNL…</option>}
      </select>
      {mancante && !aggiungi && puoScrivere && (
        <button type="button" style={{ ...stili.btnSmall, marginTop: '0.3rem' }} onClick={() => setAggiungi(true)}>Aggiungi il CCNL {letto.codice}</button>
      )}
      {aggiungi && (
        <div style={{ marginTop: '0.4rem', display: 'flex', gap: '0.4rem', flexWrap: 'wrap', alignItems: 'center' }}>
          <input value={nuovo.codice} onChange={e => setNuovo(n => ({ ...n, codice: e.target.value }))} placeholder="Codice" aria-label="Codice del nuovo CCNL" style={{ ...stili.input, width: '110px' }} />
          <input value={nuovo.descrizione} onChange={e => setNuovo(n => ({ ...n, descrizione: e.target.value }))} placeholder="Nome del CCNL" aria-label="Nome del nuovo CCNL" style={{ ...stili.input, flex: 1, minWidth: '200px' }} />
          <button type="button" style={stili.btnSmall} onClick={salva} disabled={!nuovo.codice.trim() || !nuovo.descrizione.trim()}>Aggiungi</button>
          <button type="button" style={stili.btnSmall} onClick={() => setAggiungi(false)}>Annulla</button>
        </div>
      )}
      {errore && <div style={{ fontSize: '0.78rem', color: '#b91c1c', marginTop: '0.2rem' }}>{errore}</div>}
    </div>
  );
}
